import React from "react";
import Imagen_wwa from "../../../../new_images/Landing/Photos_Top/Photos_top_conductor_tarde.png";
import Imagen_com from "../../../../new_images/Landing/Photos_Top/Photos_top_coche_amigos.png";
import "./WhoWeAre.css";

class WhoaWeAre extends React.Component {
  render() {
    return (
      <div id="apppage">
        <section>
          <div id="somos" className="row wwa_container row-cols-1 row-cols-md-2">
            <div className="col-lg-6">
              <p className="wwa_title">¿Quiénes Somos?</p>
              <p className="wwa_subtitle">
                La solución a la falta de transporte compartido accesible
              </p>
              <p className="wwa_body">
                Ya sea que necesites llegar pronto a tu destino o que desees
                ganar dinero en tu propio horario. Tovo brinda la mejor solución
                para mejorar la experiencia de pasajeros y conductores del
                transporte compartido.
              </p>
            </div>

            <div className="col-lg-5 col-md-12 col-sm-12">
              <img
                src={Imagen_wwa}
                object-fit="width"
                width="100%"
                alt="logo"
              />
            </div>
          </div>

          <div className="row wwa_container2 row-cols-1 row-cols-md-2">
            <div id="imag_com" className="col-lg-5">
              <img 
                src={Imagen_com}
                object-fit="width"
                width="100%"
                alt="logo"
              />
            </div>
            <div className="col-lg-6">
              <p id="comunidad" className="wwa_title">Crea comunidades</p>
              <p id="sub" className="wwa_subtitle">
                Se libre de compartir viajes con gente que comparte un mismo
                destino
              </p>
              <p id="descrip" className="wwa_body">
                Tovo te brinda la posibilidad de compartir viajes con personas
                de tu trabajo, universidad, familia, entre otros.
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default WhoaWeAre;
